import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import InputGroup from 'react-bootstrap/InputGroup';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';

import Cookies from 'js-cookie'
import './css/footer.css';


export default class Footer extends Component{
  state={
    readedTime:'',
    _from:'',
    _to:''
  }
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount () {
    //fetch(`https://api.hello-remix.com/check_updated_at/?token=bb7773835859debab60572f21dbaf133c09ef6d16d970aa8ac921038946e7b3a&name=%E5%A4%A7%E5%B3%B6&type=inventory&val=updated_at`)
    //  .then(res => res.json())
    //  .then(json => console.log('OK'));
    let todayDate = new Date();
    let dateStr = todayDate.getFullYear() + '-' + (todayDate.getMonth()+1) + '-' + todayDate.getDate() +' '+ todayDate.getHours()+':'+todayDate.getMinutes();
    this.setState({readedTime:dateStr});


    let _toObj = new Date(todayDate.setDate(todayDate.getDate() + 1));
    let _to = _toObj.getFullYear() + '-' + (_toObj.getMonth()+1) + '-' + _toObj.getDate() ;
		let _fromObj = new Date(todayDate.setDate(todayDate.getDate() - this.props.data._from));
		let _from = _fromObj.getFullYear() + '-' + (_fromObj.getMonth()+1) + '-' + _fromObj.getDate() ;
    this.setState({_from:_from});
    this.setState({_to:_to});
  }
  

  handleChange = (e) => {
    console.dir(e);
  }
  
  
  
  render(){
    return (
      <footer>
        <div className="readed-time ">
          ページ読み込み時刻：{this.state.readedTime}
        </div>
        <div className="readed-time info-date-range">
          表示中のデータ範囲： {this.state._from} 〜 {this.state._to}
        </div>
      </footer>
    );
  }
}